import React from "react";
import "./section4.css";

const StepSection = () => {
  return (
    <div className="section">
      <h1 className="heading">Develop Master <span className="highlight">Cybersecurity </span> Skills & Protect Your <span className="highlight">Digital Future</span></h1>

      <div className="steps">

        {/* Step 1 */}
        <div className="step">
          <div className="icon orange">&lt;/&gt;</div>
          <div className="line1"></div>
          <h2 className="title learn">Learn</h2>
          <h3 className="title1">Master the Foundations of Cybersecurity</h3>
          <p>
           Learn cybersecurity, ethical hacking, network security, at your own pace, apply skills in real-world labs, and emerge with the credibility
          </p>
        </div>

        {/* Step 2 */}
        <div className="step">
          <div className="icon pink">↻</div>
          <div className="line2"></div>
          <h2 className="title practice">Practice</h2>
          <h3 className="title2">Apply Your Skills in Real-World Scenarios</h3>
          <p>
           Every course is built around real attack scenarios, globally recognised frameworks, and mentorship from practitioners who work in the field every day.
          </p>
        </div>

        {/* Step 3 */}
        <div className="step">
          <div className="icon purple">⚙</div>
          <div className="line3"></div>
          <h2 className="title prove">Prove</h2>
          {/* <h3 className="title3">Get Certified & Launch Your Cybersecurity Career</h3> */}
           <h3 className="title3">Validate Your Skills & Get Industry-Ready</h3>
          <p>
            Go beyond learning — earn certifications built on real-world assessments that reflect what employers actually test for. Every credential you earn here carries the weight of genuine expertise, not just course completion
          </p>
        </div>

      </div>
    </div>
  );
};

export default StepSection;